module.exports = __webpack_public_path__ + "static/media/ET.fae7e270.svg";